import React, { useState, useEffect } from 'react';
import { APP_API_URL, APP_NAME } from '../../utils';

import axios from 'axios';
import { formatDate } from '../../utils/functions';
import { Link } from 'react-router-dom';
import MagasinierLayout from '../../layout/magasinier-layout';
import Loader from '../../components/loader';

export default function ControllerValidatedPage() {
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [sortConfig, setSortConfig] = useState({ key: 'created_at', direction: 'descending' });

  const [isOpen, setIsOpen] = useState(false);

  // États pour les filtres
  const [selectedDate, setSelectedDate] = useState('');
  const [appliedDate, setAppliedDate] = useState('');

  // États pour les données
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${APP_API_URL}/controller-orders/validated`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      setData(response.data.commandes);
    } catch (error) {
      console.error('Erreur lors de la récupération des commandes :', error);
    } finally {
      setLoading(false); // Fin du chargement
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const applyFilters = () => {
    setAppliedDate(selectedDate);
    setCurrentPage(1);
  };

  useEffect(() => {
    let result = data;

    const matchesDate = (item) => appliedDate ? new Date(item.created_at).toDateString() === new Date(appliedDate).toDateString() : true;

    result = result.filter(item => matchesDate(item));

    result = result.filter(item =>
      item.statut_commande.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.telephone.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.designation?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    setFilteredData(result);
    setCurrentPage(1);
  }, [searchTerm, data, appliedDate]);

  const sortedItems = [...filteredData].sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key]) {
      return sortConfig.direction === 'ascending' ? -1 : 1;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return sortConfig.direction === 'ascending' ? 1 : -1;
    }
    return 0;
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedItems.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(sortedItems.length / itemsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const requestSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const handleRefresh = async () => {
    await fetchData();
    setCurrentPage(1);
  };

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <MagasinierLayout>
      <div className="mx-auto w-full min-h-full max-w-6xl bg-white p-4 sm:p-6 lg:p-8">
        <div className='flex flex-col lg:flex-row lg:justify-between lg:items-center mb-16'>
          <div className="pagetitle">
            <h1>Historique des Commandes Validées</h1>
            <nav>
              <ol className="breadcrumb">
                <li className="breadcrumb-item active">Voir l'historique des commandes validées par moi</li>
              </ol>
            </nav>
          </div>

          <div className='flex flex-col lg:flex-row gap-x-2 gap-y-4'>
            <div className='flex flex-row gap-x-2'>
              <button title='Rafraichir' onClick={handleRefresh} type="button" className="inline-flex items-center border rounded-md bg-gray-50 px-2.5 py-2 text-sm font-semibold text-gray-950 hover:bg-gray-300 transition-all duration-300">
                <i className="bi bi-arrow-clockwise"></i>
              </button>
            </div>
          </div>
        </div>

        <section className='section'>
          <div className="card mb-4">
            <div className="card-header pb-4">
              <div className="row justify-content-between">
                <div className="col-md-6">
                  <div>
                    <input
                      type="search"
                      className="form-control"
                      placeholder="Rechercher..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>

                <div className="flex items-center justify-end gap-x-2 col-lg-2 col-md-6 mt-3 mt-md-0">
                  <button
                    type="button"
                    title='Options de filtrage'
                    onClick={toggleAccordion}
                    className={`inline-flex items-center border rounded-md px-3 py-2 text-sm font-semibold hover:bg-gray-300 transition-all duration-300 ${isOpen ? 'bg-red-500 text-white' : 'bg-gray-50 text-gray-950'}`}
                  >
                    <i className={`bi ${isOpen ? 'bi-x-lg' : 'bi-funnel-fill'}`}></i>
                  </button>
                </div>
              </div>

              <div className="accordion" id="accordionExample">
                <div className="accordaion-item">
                  <div className={`transition-max-height duration-300 ease-in-out overflow-hidden ${isOpen ? 'md:max-h-20' : 'max-h-0'}`}>
                    <div className="accordion-body px-0 border-t my-4">
                      <form className="row g-3">
                        <div className="col-md-8">
                          <div className="row">
                            <div className="col-md-3">
                              <input
                                type="date"
                                className="form-control"
                                placeholder="Choisissez une date"
                                value={selectedDate}
                                onChange={e => setSelectedDate(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className='flex justify-end'>
                            <button type="button" onClick={applyFilters} className="inline-flex items-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 transition-all duration-300">
                              <i className="bi bi-search me-1" /> Recherche
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="card-body p-0">
              <div className="table-responsive table-card">
                <table className="table text-nowrap mb-0 table-centered table-hover">
                  <thead className="table-light">
                    <tr>
                      <th className="ps-3" onClick={() => requestSort('designation')}>
                        <button className='inline-flex items-center justify-between w-full'>
                          Référence de la commande
                          <i className="bi bi-arrow-down-up text-gray-400"></i>
                        </button>
                      </th>
                      <th className="ps-3" onClick={() => requestSort('telephone')}>
                        <button className='inline-flex items-center justify-between w-full'>
                          Téléphone
                          <i className="bi bi-arrow-down-up text-gray-400"></i>
                        </button>
                      </th>
                      <th className="ps-3">
                        <button
                          className='inline-flex items-center justify-between w-full'
                          onClick={() => requestSort('created_at')}
                        >
                          Date de création
                          <i className="bi bi-arrow-down-up text-gray-400 ml-2"></i>
                        </button>
                      </th>
                      <th>
                        <button>Action</button>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.length > 0 ? (
                      currentItems.map((item, index) => (
                        <tr key={'Commande-' + index} className='align-middle'>
                          <td className="ps-3 font-semibold">
                            {item.designation}
                          </td>
                          <td>
                            {item.telephone}
                          </td>
                          <td>
                            {formatDate(item.created_at)}
                          </td>
                          <td style={{ whiteSpace: 'normal' }}>
                            <Link to={`/orders/${item.designation}`}
                              className="btn btn-ghost btn-icon bg-lightgreen hover:bg-lime-800 text-white btn-xs rounded-xl texttooltip border"
                              title="Voir"
                            >
                              <div className='flex flex-row'>
                                <i className="bi bi-eye"></i>
                                <div id="editOne" className="d-none">
                                  <span>Voir</span>
                                </div>
                              </div>
                            </Link>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className="datatable-empty" colSpan="10">Aucun item correspondant aux critères de recherche.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="card-footer d-md-flex justify-content-between align-items-center">
              <span>
                {currentItems.length > 0
                  ? `Affichage de ${Math.max(indexOfFirstItem + 1, 0)} à ${Math.min(indexOfLastItem, currentItems.length)} sur ${sortedItems.length} entrée${sortedItems.length > 1 ? 's' : ''}`
                  : `Aucune entrée à afficher`}
                {currentItems.length === 0 && data.length > 0 && ` (filtré à partir de ${data.length} entrée${data.length > 1 ? 's' : ''} totales)`}
              </span>

              {currentItems.length > 0 && (
                <nav className="mt-2 mt-md-0">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <a className="page-link" href="#!" onClick={handlePrevPage} disabled={currentPage === 1}>
                        Précédent
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="#!" onClick={handleNextPage} disabled={currentPage === totalPages}>
                        Suivant
                      </a>
                    </li>
                  </ul>
                </nav>
              )}
            </div>
          </div>
        </section>
      </div>
    </MagasinierLayout>
  );
};